import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TChartsData } from "@ts/common-types";
import { Ref } from "react";

type TChartsDataValue = {
    chartsData: TChartsData[];
};

const chartsDataSlice = createSlice({
    name: "chartsData",
    initialState: { value: {} },
    reducers: {
        updateChartsData: (state, action: PayloadAction<TChartsDataValue>) => {
            state.value = action.payload;
        },
    },
});

const funnelChartsSlice = createSlice({
    name: "funnelChartsRef",
    initialState: { value: {} },
    reducers: {
        updateFunnelChartsRef: (state, action: PayloadAction<Ref<null>>) => {
            state.value = action.payload;
        },
    },
});

const activeKeySlice = createSlice({
    name: "activeKey",
    initialState: { value: ["spend", "spend"] },
    reducers: {
        updateActiveKey: (state, action: PayloadAction<string[]>) => {
            state.value = action.payload;
        },
    },
});

export const { updateChartsData } = chartsDataSlice.actions;
export const { updateFunnelChartsRef } = funnelChartsSlice.actions;
export const { updateActiveKey } = activeKeySlice.actions;

export const chartsDataReducer = chartsDataSlice.reducer;
export const funnelChartsReducer = funnelChartsSlice.reducer;
export const activeKeyReducer = activeKeySlice.reducer;
